@if (stepInfo()) {
  <lib-accordion
    [accordionClass]="'p-lg bg-neutral-50 mb-2xl'"
    [title]="stepInfo().name"
    [isOpen]="!!stepInfo().isExpanded"
    [titleClass]="'font-semibold text-neutral-900 text-base'"
    [disableToggle]="disableExpand()"
    [detailsClass]="'my-2xl px-lg'"
    (toggleAccordion)="toggleAccordion(stepInfo())">
    <!-- Step Info Header -->
    <div class="flex items-center justify-between mb-2xl">
      <h5 class="font-medium text-neutral-900 text-base">
        {{
          'workflow_configurations_details_screen_accordion_details_title'
            | transloco
        }}
      </h5>

      <button
        id="workflow_configurations_details_screen_edit_button"
        class="flex items-center bg-transparent gap-sm text-base text-primary-600 font-medium py-sm px-xl cursor-pointer"
        type="button"
        (click)="switchToEditMode.emit(stepInfo())">
        <lib-edit-icon [iconClass]="'size-5 text-primary-600'" />

        {{ 'workflow_configurations_details_screen_edit_button' | transloco }}
      </button>
    </div>

    <!-- Step Sections -->
    <div class="flex flex-col gap-sm">
      <!-- Assignees Info -->
      <section class="flex gap-lg border-b border-neutral-200 pb-md">
        <div class="w-40 shrink-0 font-medium text-sm text-neutral-900">
          {{
            'workflow_configurations_details_screen_assignees_info_section_title'
              | transloco
          }}
        </div>

        <div class="flex flex-col gap-lg flex-1 min-w-0">
          @for (
            assignee of stepInfo().assignees;
            track $index;
            let last = $last
          ) {
            <div [class.border-b]="!last" [class.border-neutral-200]="!last">
              <div class="flex flex-wrap gap-lg mb-lg" [class.pb-lg]="!last">
                <!-- Resource Type -->
                <div class="flex flex-col w-50">
                  <div class="font-medium text-xs2 text-neutral-500">
                    {{
                      'workflow_configurations_details_screen_resource_type_label'
                        | transloco
                    }}
                  </div>
                  @if (assignee?.type === 'fields') {
                    <p class="font-semibold text-xs text-neutral-900">
                      {{ 'workflow_step_info_form_{fields}_label' | transloco }}
                    </p>
                  } @else if (assignee?.assignable_type) {
                    <p class="font-semibold text-xs text-neutral-900">
                      {{
                        'workflow_step_info_form_{' +
                          assignee?.assignable_type +
                          '}_label' | transloco
                      }}
                    </p>
                  } @else {
                    <p class="font-semibold text-xs text-neutral-900">
                      {{
                        'workflow_step_info_form_{' + assignee?.type + '}_label'
                          | transloco
                      }}
                    </p>
                  }
                </div>
                <!-- VARIABLE OPTION  -->

                @if (
                  !assignee?.assignable_type && assignee?.type === 'variable'
                ) {
                  <div class="flex flex-col w-50">
                    <div class="font-medium text-xs2 text-neutral-500">
                      {{
                        'workflow_step_info_form_variable option_label'
                          | transloco
                      }}
                    </div>

                    <p class="font-semibold text-xs text-neutral-900">
                      {{ assignee.data.name }}
                    </p>
                  </div>
                }

                <!-- VARIABLE OPTION  -->

                <!-- Resource Option -->
                @if (
                  assignee.assignable_type === 'department' ||
                  assignee.assignable_type === 'group' ||
                  assignee.assignable_type === 'legal_entity'
                ) {
                  @if (
                    assignee?.option &&
                    assignee.assignable_type !== 'legal_entity'
                  ) {
                    <div class="flex flex-col w-50">
                      <div class="font-medium text-xs2 text-neutral-500">
                        {{
                          'workflow_step_info_form_assignable_option_label'
                            | transloco
                        }}
                      </div>

                      <p class="text-neutral-900 font-semibold text-xs">
                        {{
                          assignee?.option.value !== 'members_and_sub_members'
                            ? assignee?.option.label
                            : ('workflow_step_info_form_member_sub_department_members_label'
                              | transloco)
                        }}
                      </p>
                    </div>
                  }
                }

                <!-- Resource -->
                @if (
                  assignee?.type === 'static' ||
                  assignee?.type === 'project_role' ||
                  assignee?.type === 'fields'
                ) {
                  <div class="flex flex-col w-50">
                    <div class="font-medium text-xs2 text-neutral-500">
                      <ng-container
                        [ngTemplateOutlet]="type"
                        [ngTemplateOutletContext]="{
                          $implicit: assignee?.assignable_type,
                        }" />
                    </div>

                    <div class="flex items-center gap-sm">
                      <lib-avatar
                        [fullName]="assignee?.data.name || ''"
                        [img]="assignee?.data?.image?.url || ''"
                        [size]="''"
                        [imgDimensions]="{ width: 24, height: 24 }"
                        [placeholderTextClass]="'text-xs'"
                        [borderRadius]="'rounded-full'" />

                      <div
                        class="font-semibold text-xs text-neutral-900 trim-text">
                        {{ assignee?.data.name }}
                      </div>
                    </div>
                  </div>
                }

                @if (
                  assignee.assignable_type === 'department' ||
                  assignee.assignable_type === 'group' ||
                  assignee.assignable_type === 'legal_entity'
                ) {
                  <!-- Assignees Preference -->
                  @if (assignee?.option?.value !== 'manager') {
                    <div class="flex flex-col w-50">
                      <div class="font-medium text-xs2 text-neutral-500">
                        {{
                          'workflow_step_info_form_assignees_preference_label'
                            | transloco
                        }}
                      </div>

                      <p class="text-neutral-900 font-semibold text-xs">
                        {{
                          assignee.preference
                            ? ('workflow_step_info_form_at_least_label'
                              | transloco)
                            : ('workflow_step_info_form_all_assignees_label'
                              | transloco)
                        }}
                      </p>
                    </div>
                  }

                  <!-- Number of Assignees -->
                  @if (assignee.preference) {
                    <div class="flex flex-col w-50">
                      <div class="font-medium text-xs2 text-neutral-500">
                        {{
                          'workflow_step_info_form_number_of_assignees_label'
                            | transloco
                        }}
                      </div>

                      <p class="text-neutral-900 font-semibold text-xs2">
                        {{ assignee.preference }}
                      </p>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      </section>

      <!-- Assignment Preference Section  -->
      <section class="flex gap-lg border-b border-neutral-200 py-md">
        <div class="w-40 shrink-0 text-neutral-900 font-medium text-sm">
          {{
            'workflow_step_info_form_assignment_preference_label' | transloco
          }}
        </div>

        <div class="flex-1 min-w-0">
          <p class="text-neutral-500 font-semibold text-xs2">
            {{
              'workflow_step_info_form_assignment_preference_label' | transloco
            }}
          </p>

          <p class="text-neutral-900 font-semibold text-xs">
            {{ 'workflow_step_info_form_and_label' | transloco }}
          </p>
        </div>
      </section>

      <section class="flex py-lg gap-lg border-b border-neutral-200">
        <div class="w-40 shrink-0 font-medium text-sm text-neutral-900">
          {{
            'workflow_configurations_details_screen_sla_section_title'
              | transloco
          }}
        </div>

        <div
          class="grid [grid-template-columns:repeat(auto-fill,minmax(10rem,1fr))] gap-lg flex-1 min-w-0">
          <div class="flex flex-col">
            <div class="font-medium text-xs2 text-neutral-500">
              {{ 'workflow_step_info_form_sla_type_label' | transloco }}
            </div>

            <div class="font-semibold text-xs text-neutral-900">
              {{
                'workflow_step_info_form_' + stepInfo().sla.type + '_label'
                  | transloco
              }}
            </div>
          </div>

          <div class="flex flex-col">
            <div class="font-medium text-xs2 text-neutral-500">
              @if (stepInfo().sla.type === slaTypeEnum.STATIC) {
                {{
                  'workflow_configurations_details_screen_estimated_completion_time_label'
                    | transloco
                }}
              } @else {
                {{ 'workflow_step_info_form_sla_variable_label' | transloco }}
              }
            </div>

            <div class="font-semibold text-xs text-neutral-900">
              @if (stepInfo().sla.type === slaTypeEnum.STATIC) {
                {{ stepInfo().sla.value }} -
                {{
                  'workflow_configurations_details_screen_working_hours_label'
                    | transloco
                }}
              } @else {
                {{ stepInfo().sla.variable.label }}
              }
            </div>
          </div>
        </div>
      </section>

      <section class="flex py-lg gap-lg border-b border-neutral-200">
        <div class="w-40 shrink-0 font-medium text-sm text-neutral-900">
          {{
            'workflow_configurations_details_screen_sla_escalations_section_title'
              | transloco
          }}
        </div>

        <div
          class="flex-1 min-w-0 grid [grid-template-columns:repeat(auto-fill,minmax(10rem,1fr))] gap-lg mb-lg">
          <div class="flex flex-col">
            <div class="font-medium text-xs2 text-neutral-500">
              {{
                'workflow_configurations_details_screen_when_label' | transloco
              }}
            </div>

            <div class="font-semibold text-xs text-neutral-900">
              {{
                stepInfo().escalation
                  ? ('workflow_step_info_form_at_deadline_label' | transloco)
                  : ('details_not_found_label' | transloco)
              }}
            </div>
          </div>

          <div class="flex flex-col">
            <div class="font-medium text-xs2 text-neutral-500">
              {{
                'workflow_configurations_details_screen_escalations_actions_label'
                  | transloco
              }}
            </div>

            <div class="font-semibold text-xs text-neutral-900">
              {{
                stepInfo().escalation?.escalation_type?.label
                  ? stepInfo().escalation?.escalation_type?.label
                  : ('details_not_found_label' | transloco)
              }}
            </div>
          </div>

          <div class="flex flex-col">
            <div class="font-medium text-xs2 text-neutral-500">
              {{
                'workflow_configurations_details_screen_resource_type_label'
                  | transloco
              }}
            </div>

            <div class="font-semibold text-xs text-neutral-900">
              {{
                stepInfo().escalation?.stakeholder_type
                  ? ('workflow_step_info_form_{' +
                      stepInfo().escalation?.stakeholder_type +
                      '}_label' | transloco)
                  : null
              }}

              {{
                stepInfo().escalation?.type &&
                !stepInfo().escalation?.stakeholder_type
                  ? ('workflow_step_info_form_{' +
                      stepInfo().escalation?.type?.value +
                      '}_label' | transloco)
                  : null
              }}

              {{
                !stepInfo().escalation?.type &&
                !stepInfo().escalation?.stakeholder_type
                  ? ('details_not_found_label' | transloco)
                  : null
              }}
            </div>
          </div>

          <div class="flex flex-col">
            <div class="font-medium text-xs2 text-neutral-500">
              <ng-container
                [ngTemplateOutlet]="type"
                [ngTemplateOutletContext]="{
                  $implicit:
                    stepInfo().escalation?.stakeholder_type ||
                    stepInfo().escalation?.type?.value,
                }" />
            </div>

            @if (stepInfo().escalation?.stakeholder_type) {
              <div class="flex items-center gap-sm">
                <lib-avatar
                  [fullName]="
                    stepInfo().escalation?.stakeholder_data?.name ?? ''
                  "
                  [img]="
                    stepInfo().escalation?.stakeholder_data?.image?.url ?? ''
                  "
                  [size]="''"
                  [imgDimensions]="{ width: 24, height: 24 }"
                  [placeholderTextClass]="'text-xs'"
                  [borderRadius]="'rounded-full'" />

                <div class="font-semibold text-xs text-neutral-900 trim-text">
                  {{ stepInfo().escalation?.stakeholder_data?.name }}
                </div>
              </div>
            } @else {
              <div class="font-semibold text-xs text-neutral-900">
                {{ stepInfo().escalation?.stakeholder_data?.name }}
              </div>
            }
          </div>
        </div>
      </section>

      <section class="flex py-lg gap-lg border-b border-neutral-200">
        <div class="w-40 shrink-0 font-medium text-sm text-neutral-900">
          {{
            'workflow_configurations_details_screen_when_section_title'
              | transloco
          }}
        </div>

        <div class="flex flex-col flex-1 min-w-0">
          <div class="font-medium text-xs2 text-neutral-500">
            {{
              'workflow_configurations_details_screen_when_label' | transloco
            }}
          </div>

          <div class="font-medium text-xs text-neutral-900">
            @if (stepInfo().when) {
              {{
                'workflow_configurations_details_screen_based_on_conditions_label'
                  | transloco
              }}
            } @else {
              {{
                'workflow_configurations_details_screen_always_label'
                  | transloco
              }}
            }
          </div>
        </div>

        @if (stepInfo().when) {
          <div class="flex flex-col flex-1">
            <div class="font-medium text-xs2 text-neutral-500">
              {{
                'workflow_configurations_details_screen_condition_label'
                  | transloco
              }}
            </div>

            <div class="font-medium text-xs text-neutral-900">
              {{ stepInfo().when }}
            </div>
          </div>
        }
      </section>

      <!-- Actions -->
      @if (stepInfo().position !== 1) {
        <section class="flex py-lg gap-lg border-b border-neutral-200">
          <div class="w-40 shrink-0 font-medium text-sm text-neutral-900">
            {{
              'workflow_configurations_details_screen_actions_section_title'
                | transloco
            }}
          </div>

          <div
            class="grid [grid-template-columns:repeat(auto-fill,minmax(10rem,1fr))] gap-lg flex-1 min-w-0">
            <!-- Send Back -->
            <div class="flex flex-col">
              <div class="font-medium text-xs2 text-neutral-500">
                {{
                  'workflow_configurations_details_screen_send_back_label'
                    | transloco
                }}
              </div>
              <div
                class="font-semibold text-xs"
                libStepActionValue
                [action]="requestActionsEnum.SENDBACK"
                [actionList]="stepInfo().actions"
                [enabledLabel]="'workflow_step_info_form_yes_label' | transloco"
                [disabledLabel]="
                  'workflow_step_info_form_no_label' | transloco
                "></div>
            </div>

            <!-- Number of Steps -->
            <div class="flex flex-col">
              <div class="font-medium text-xs2 text-neutral-500">
                {{
                  'workflow_configurations_details_screen_number_of_steps_label'
                    | transloco
                }}
              </div>

              <div class="font-semibold text-xs text-neutral-900">
                @if (numberOfBackSteps() > 0) {
                  {{
                    numberOfBackSteps() +
                      ' ' +
                      ('workflow_configurations_details_screen_step_back_option_label'
                        | transloco)
                  }}
                } @else {
                  {{ 'details_not_found_label' | transloco }}
                }
              </div>
            </div>

            <!-- Reject This Step & Send Forward -->
            <div class="flex flex-col">
              <div class="font-medium text-xs2 text-neutral-500">
                {{
                  'workflow_configurations_details_screen_send_forward_label'
                    | transloco
                }}
              </div>

              <div
                class="font-semibold text-xs"
                libStepActionValue
                [action]="requestActionsEnum.SENDFORWARD"
                [actionList]="stepInfo().actions"
                [enabledLabel]="'workflow_step_info_form_yes_label' | transloco"
                [disabledLabel]="
                  'workflow_step_info_form_no_label' | transloco
                "></div>
            </div>

            <!-- Reassign -->
            <div class="flex flex-col">
              <div class="font-medium text-xs2 text-neutral-500">
                {{
                  'workflow_configurations_details_screen_reassign_label'
                    | transloco
                }}
              </div>

              <div
                class="font-semibold text-xs"
                libStepActionValue
                [action]="requestActionsEnum.REASSIGN"
                [actionList]="stepInfo().actions"
                [enabledLabel]="'workflow_step_info_form_yes_label' | transloco"
                [disabledLabel]="
                  'workflow_step_info_form_no_label' | transloco
                "></div>
            </div>
            <!-- Reject The Request -->
            <div class="flex flex-col">
              <div class="font-medium text-xs2 text-neutral-500">
                {{
                  'workflow_configurations_details_screen_reject_label'
                    | transloco
                }}
              </div>

              <div
                class="font-semibold text-xs"
                libStepActionValue
                [action]="requestActionsEnum.REJECT"
                [actionList]="stepInfo().actions"
                [enabledLabel]="'workflow_step_info_form_yes_label' | transloco"
                [disabledLabel]="
                  'workflow_step_info_form_no_label' | transloco
                "></div>
            </div>
          </div>
        </section>
      }

      @if (hasConfiguredStepActions()) {
        <section class="flex py-lg gap-lg border-b border-neutral-200">
          <div class="w-40 shrink-0 font-medium text-sm text-neutral-900">
            {{ 'workflow_step_info_form_wf_actions_section_title' | transloco }}
          </div>

          <div
            class="grid [grid-template-columns:repeat(auto-fill,minmax(10rem,1fr))] gap-lg flex-1 min-w-0">
            @for (
              action of configuredStepActions();
              track action.id;
              let index = $index;
              let last = $last
            ) {
              <div
                class="bg-white border-neutral-200 flex flex-col gap-lg"
                [class.pb-lg]="!last"
                [class.border-b]="!last">
                <div
                  class="grid [grid-template-columns:repeat(auto-fill,minmax(10rem,1fr))] gap-lg">
                  <div class="flex flex-col">
                    <div class="font-medium text-xs2 text-neutral-500">
                      {{ 'workflow_step_info_form_when_label' | transloco }}
                    </div>
                    <div class="font-semibold text-xs text-neutral-900">
                      {{ action.when.label }}
                    </div>
                  </div>

                  <div class="flex flex-col">
                    <div class="font-medium text-xs2 text-neutral-500">
                      {{ 'workflow_step_info_form_action_label' | transloco }}
                    </div>
                    <div class="font-semibold text-xs text-neutral-900">
                      {{ action.type.label }}
                    </div>
                  </div>
                </div>

                <div class="flex flex-col">
                  <div class="font-medium text-xs2 text-neutral-500">
                    {{ 'workflow_step_info_form_users_label' | transloco }}
                  </div>

                  @if (action.users.length) {
                    <lib-user-dropdown-view
                      [userCount]="action.users.length"
                      [userTableList]="action.users"
                      [userDropdownList]="action.users"
                      [totalDropdownCount]="action.users.length"
                      [enableLocalSearch]="true"
                      [imgDimensions]="{ width: 1.5, height: 1.5 }"
                      [containerRef]="
                        'workflow-step-info-view-step-action-' +
                        stepInfo().id +
                        '-' +
                        action.id
                      "
                      [searchLabel]="
                        'dropdown_search_find_users_label' | transloco
                      "
                      [searchPlaceholder]="
                        'search_by_name_placeholder' | transloco
                      "
                      [headerListLabel]="
                        'workflow_step_info_form_users_label' | transloco
                      "
                      [noSearchResultLabel]="
                        'no_search_result_label' | transloco
                      " />
                  } @else {
                    <div class="font-semibold text-xs text-neutral-900">
                      {{ 'details_not_found_label' | transloco }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </section>
      }

      @if (stepInfo().completion_action) {
        <!-- Rename Buttons / Completion Action Section -->
        <section class="flex py-lg gap-lg border-b border-neutral-200">
          <div class="w-40 shrink-0 font-medium text-sm text-neutral-900">
            {{
              'workflow_configurations_details_screen_rename_buttons_section_title'
                | transloco
            }}
          </div>

          <div class="flex flex-col flex-1 min-w-0">
            <div class="font-medium text-xs2 text-neutral-500">
              {{
                'workflow_configurations_details_screen_completion_action_label'
                  | transloco
              }}
            </div>

            <div class="font-semibold text-xs text-neutral-900">
              {{
                'workflow_configurations_details_screen_completion_action_' +
                  stepInfo().completion_action | transloco
              }}
            </div>
          </div>
        </section>
      }
    </div>
  </lib-accordion>
}

<ng-template #type let-type>
  @switch (type) {
    @case ('user') {
      {{ 'workflow_configurations_details_screen_assignee_label' | transloco }}
    }

    @case ('group') {
      {{ 'workflow_configurations_details_screen_group_label' | transloco }}
    }

    @case ('department') {
      {{
        'workflow_configurations_details_screen_department_label' | transloco
      }}
    }

    @case ('legal_entity') {
      {{ 'workflow_step_info_form_{legal_entity}_label' | transloco }}
    }

    @case ('project_role') {
      {{ 'workflow_step_info_project_role_label' | transloco }}
    }

    @case ('variable') {
      {{ 'workflow_step_info_form_{variable}_label' | transloco }}
    }

    @case ('field') {
      {{ 'workflow_step_info_form_{fields}_label' | transloco }}
    }
  }
</ng-template>
